<template>
  <span :class="{ 'green--text': value > 0, 'red--text': value < 0 || value === undefined }">{{text}}</span>
</template>

<script>
import { percent } from "@/filters";
import { coinDesc } from "@/api/const";

const formatters = {
  profit(value, digits, coin) {
    const priceFactor = coin ? coinDesc[coin].unitFactor : 1;
    const sign = value > 0 ? '+' : value < 0 ? '-' : '';
    return `${sign}$${Math.abs(value * priceFactor).toFixed(digits)}`;
  },
  breakeven(value) {
    if (value > 0) return value.toFixed(0);
    else return '∞';
  },
  percent
};

export default {
  name: "Colored",
  props: ["value", "digits", "coin", "format"],
  computed: {
    text() {
      return formatters[this.format || "profit"](this.value, this.digits, this.coin);
    }
  }
}
</script>

<style scoped>

</style>